import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { CATEGORIES, CONTACT, MENU } from '../data/site';

export default function MenuSection() {
  const [active, setActive] = useState('hamburgers');
  const items = MENU.filter((m) => m.category === active);

  return (
    <section id="cardapio" className="py-24 sm:py-32" data-testid="cardapio-section">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="font-mono-alt text-xs font-semibold uppercase tracking-[0.3em] text-[#FFB800]"
        >
          Cardápio
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-4 font-display text-5xl uppercase leading-none text-white sm:text-6xl"
        >
          Feito com amor, servido com orgulho
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="font-serif-accent mt-4 text-xl text-zinc-400"
        >
          Explore nossas criações artesanais.
        </motion.p>

        <div className="mt-10 flex flex-wrap gap-2">
          {CATEGORIES.map((c, i) => (
            <button
              key={c.key}
              onClick={() => setActive(c.key)}
              data-testid={`cardapio-category-tab-${i}`}
              className={`rounded-full border px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-all duration-300 ${
                active === c.key
                  ? 'border-[#FF5500] bg-[#FF5500] text-[#0D0D0F] shadow-[0_0_20px_rgba(255,85,0,0.35)]'
                  : 'border-white/15 text-zinc-400 hover:border-white/40 hover:text-white'
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.35 }}
            className="mt-10 divide-y divide-white/10"
            data-testid="cardapio-items-list"
          >
            {items.map((item) => (
              <div key={item.id} className="group py-6" data-testid={`cardapio-item-card-${item.id}`}>
                <div className="flex items-baseline gap-4">
                  <h3 className="text-lg font-bold text-white transition-colors group-hover:text-[#FF5500] sm:text-xl">
                    {item.name}
                  </h3>
                  <span className="mx-1 flex-1 -translate-y-1 border-b border-dotted border-white/20" />
                  <span className="font-display text-2xl text-[#FFB800]">
                    <span className="mr-1 align-middle text-sm text-zinc-500">R$</span>
                    {item.price}
                  </span>
                </div>
                {item.description && (
                  <p className="mt-2 max-w-2xl text-sm text-zinc-400">{item.description}</p>
                )}
              </div>
            ))}
          </motion.div>
        </AnimatePresence>

        <div className="mt-12 flex justify-center">
          <a
            href={CONTACT.ifood}
            target="_blank"
            rel="noreferrer"
            data-testid="cardapio-ifood-cta-button"
            className="inline-flex items-center gap-2 rounded-full bg-[#EA1D2C] px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_36px_rgba(234,29,44,0.5)]"
          >
            <ShoppingBag size={16} /> Peça agora online
          </a>
        </div>
      </div>
    </section>
  );
}
